import { Icons } from "../models/assets-files";
import { ProductOrServiceId } from "./products-and-services";

export interface AppBarCategoryItem {
  id: string;
  title: string;
  icon: string;
  path?: string;
  subCategories?: AppBarSubCategoryItem[];
}

interface AppBarSubCategoryItem {
  title: string;
  path?: string;
  icon: string;
  id: string;
}

export interface AppBarCategorySection {
  title?: string;
  categoryItems: AppBarCategoryItem[];
}

export enum AppBarListItemId {
  DASHBOARD = "dashboard",
  PAYMENT = "payment",
  UPLOADED_FILES = "uploaded-files",
  SCAMMERS_LIBRARY = "scammers-library",
  IDENTITY_THEFT_CHECKER = "identity-theft-checker",
  WALLET_WATCHLIST = "wallet-watchlist",
  GENERATE_PASSWORD = "generate-password",
  SETTINGS = "settings",
  PRODUCTS_AND_SERVICES = "products-and-services",
  ADMIN_CLIENTS = "admin-clients",
  ADMIN_MANAGEMENT = "admin-management",
}

export const AppBarMenuListSections: AppBarCategorySection[] = [
  {
    title: "Navigation",
    categoryItems: [
      {
        id: AppBarListItemId.DASHBOARD,
        path: `/`,
        title: "Dashboard",
        icon: Icons.AppBarMenu.Dashboard,
      },
      {
        id: AppBarListItemId.PAYMENT,
        path: `/payment`,
        title: "Payment",
        icon: Icons.AppBarMenu.Payment,
      },
      {
        id: AppBarListItemId.PRODUCTS_AND_SERVICES,
        title: "Products & Services",
        icon: Icons.AppBarMenu.ProductsAndServices,
        subCategories: [
          {
            id: ProductOrServiceId.TRACK_MASTER,
            title: "Track Master",
            path: `/${ProductOrServiceId.TRACK_MASTER}`,
            icon: Icons.AppBarMenu.TrackMaster,
          },
          {
            id: ProductOrServiceId.WEB_INTELLIGENCE,
            title: "Web Intelligence",
            path: `/product/${ProductOrServiceId.WEB_INTELLIGENCE}`,
            icon: Icons.AppBarMenu.WebIntelligence,
          },
          {
            id: ProductOrServiceId.BLOCKCHAIN_ANALYSIS,
            path: `/blockchain-analysis/status`,
            title: "Blockchain Analysis",
            icon: Icons.AppBarMenu.BlockchainAnalysis,
          },

          {
            id: ProductOrServiceId.CORRESPONDENCE,
            path: `/product/${ProductOrServiceId.CORRESPONDENCE}`,
            title: "Correspondence",
            icon: Icons.AppBarMenu.ExchangeDispute,
          },
        ],
      },
      {
        id: AppBarListItemId.UPLOADED_FILES,
        path: `/${AppBarListItemId.UPLOADED_FILES}`,
        title: "Uploaded Files",
        icon: Icons.AppBarMenu.UploadedFiles,
      },
    ],
  },
  {
    title: "Free Extra Features",
    categoryItems: [
      {
        id: AppBarListItemId.SCAMMERS_LIBRARY,
        path: `/${AppBarListItemId.SCAMMERS_LIBRARY}`,
        title: "Scammers library",
        icon: Icons.AppBarMenu.ScammersLibrary,
      },
      // {
      //   id: AppBarListItemId.IDENTITY_THEFT_CHECKER,
      //   path: `/${AppBarListItemId.IDENTITY_THEFT_CHECKER}`,
      //   title: "Identity Theft Checker",
      //   icon: Icons.AppBarMenu.IdentityTheftChecker,
      // },
      {
        id: AppBarListItemId.WALLET_WATCHLIST,
        path: `/${AppBarListItemId.WALLET_WATCHLIST}`,
        title: "Wallet Watchlist",
        icon: Icons.AppBarMenu.WalletWatchlist,
      },
      {
        id: AppBarListItemId.GENERATE_PASSWORD,
        path: `/${AppBarListItemId.GENERATE_PASSWORD}`,
        title: "Generate Password",
        icon: Icons.AppBarMenu.GeneratePassword,
      },
    ],
  },
  {
    title: "User",
    categoryItems: [
      {
        id: AppBarListItemId.SETTINGS,
        path: `/${AppBarListItemId.SETTINGS}`,
        title: "Settings",
        icon: Icons.AppBarMenu.Settings,
      },
    ],
  },
  {
    title: "Administration",
    categoryItems: [
      {
        id: AppBarListItemId.ADMIN_CLIENTS,
        path: `/agent/clients`,
        title: "Client Management",
        icon: Icons.AppBarMenu.Settings,
      },
      {
        id: AppBarListItemId.ADMIN_MANAGEMENT,
        path: `/admin`,
        title: "Admin Management",
        icon: Icons.AppBarMenu.Settings,
      },
    ],
  },
];
